import { LDFlagSet } from 'launchdarkly-react-client-sdk';

import { DispatchedReportItem, ExportedReportItem } from '@futrli-sdk/report_scheduling';
import { PermissionInfo } from '@futrli-sdk/predict';

// Adding permission_info / report_id here is a hack until we can upgrade to @futrli-sdk/predict 1.7.30
export interface ExportedReportItemWithPerms extends ExportedReportItem {
  permission_info: PermissionInfo;
  report_id: string;
}
export interface DispatchedReportItemWithPerms extends DispatchedReportItem {
  permission_info: PermissionInfo;
  report_id: string;
}

export interface ExportedPdfListActions {
  delete: boolean;
  downloadPdf: boolean;
  emailPdf: boolean;
  viewPdf: boolean;
}

interface ExtendedExportedReportItem extends ExportedReportItemWithPerms {
  actions: ExportedPdfListActions;
  type: 'exported';
}
interface ExtendedDispatchedReportItem extends DispatchedReportItemWithPerms {
  actions: ExportedPdfListActions;
  type: 'dispatched';
}

export type ExportedPdfListItem = ExtendedExportedReportItem | ExtendedDispatchedReportItem;

export const combineExportedPdfItems = (
  exportedReports: ExportedReportItem[],
  dispatchedReports: DispatchedReportItem[],
  flags: LDFlagSet = {}
): ExportedPdfListItem[] => {
  const exported = (exportedReports as unknown) as ExtendedExportedReportItem[];
  const dispatched = (dispatchedReports as unknown) as ExtendedDispatchedReportItem[];
  const hasResourceSharing = Boolean(flags.resourceSharing);

  return [
    ...exported.map(item => ({
      ...item,
      actions: {
        delete: !hasResourceSharing || item.permission_info.effective_permission === 'edit',
        downloadPdf: true,
        emailPdf: true,
        viewPdf: true
      },
      type: 'exported' as const
    })),
    ...dispatched.map(item => ({
      ...item,
      actions: {
        delete: false,
        downloadPdf: true,
        emailPdf: false,
        viewPdf: true
      },
      type: 'dispatched' as const
    }))
  ];
};
